import { withStyles } from '@material-ui/core';

import DestinationForm from './component';
import styles from './styles';

export default withStyles(styles)(DestinationForm);
